import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow, FlexCol } from '../../Defaults/Flexbox/Flexbox';
import { OutsideClick } from '../../Defaults/OutsideClick';

export interface Props {
  closeMenu: () => void;
  children: any;
}

function MobileNavMenu({ closeMenu, children }: Props) {
  return (
    <Wrapper>
      <OutsideClick handleFunction={closeMenu}>
        <Content>{children}</Content>
      </OutsideClick>
    </Wrapper>
  );
}

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0%);
  }
`;

const Wrapper = styled(FlexRow)`
  position: absolute;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 11000;
  top: 0;
  left: 0;
  position: fixed;
  max-height: initial;

  animation: ${slideIn} 0.125s ease-in;
`;

const Content = styled(FlexCol)`
  width: 100%;
  /* padding: ${rem(20)} 0; */
  height: 100%;
  overflow-y: auto;
  width: ${rem(288)};
  position: relative;
`;

export { MobileNavMenu };
